function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getSessionToken(myValue) {
        var tokenUrl = 'https://dch-development.myshopify.com/apps/dch-webapi';
        var strData = '';
  		$.ajax({
            type: 'GET',
            url: tokenUrl,            
            success: function (data) {
            strData = JSON.stringify(data);
            strData = strData.replace(/\"/g, "");
            sessionSet("jwt", strData, 3);
        	}
        });
  		return strData;
    }

function getSessionTokenTest() {
        var tokenUrl = 'https://dch-development.myshopify.com/apps/dch-webapi';
        var strData = '';
  		$.ajax({
            type: 'GET',
            url: tokenUrl,            
            success: function (data) {
            strData = JSON.stringify(data);
            strData = strData.replace(/\"/g, "");
            sessionSet("jwt", strData, 3);
        	}
        });
  		return strData;
    }

var myValue = '';

window.onload = function() {
        getSessionToken(myValue);
		};

function sessionGet(key) {
  let stringValue = window.sessionStorage.getItem(key)
    if (stringValue !== null) {
      let value = JSON.parse(stringValue)
        let expirationDate = new Date(value.expirationDate)
        if (expirationDate > new Date()) {
          return value.value
        } else {
          window.sessionStorage.removeItem(key)
        }
    }
    return null
}

function sessionSet(key, value, expirationInMin = 10) {
  let expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin))
    let newValue = {
    value: value,
    expirationDate: expirationDate.toISOString()
  }
  window.sessionStorage.setItem(key, JSON.stringify(newValue))
}

function localSet(key, value, expirationInMin = 10) {
  let expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin))
    let newValue = {
    value: value,
    expirationDate: expirationDate.toISOString()
  }
  window.localStorage.setItem(key, JSON.stringify(newValue))
}

function delete_cookie(name) {
	document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}


function updateOnHands(variantId, qty, price)
   	{
    	var myAuth = sessionGet("jwt");
      	var shopifyUrl = 'https://dch-webapi.azurewebsites.net/api/shopify/variants/s5a/';
      	$.ajax({
        type: 'POST',
        url: shopifyUrl + variantId + '/' + qty + '/' + price,
        beforeSend: function (xhr) {
          	xhr.setRequestHeader('Authorization', 'Bearer ' + myAuth);
        }
      	}).done(function (data) {
        	//console.log(data);
      	}).fail(function (jqXHR, textStatus, errorThrown) {
        	console.log(jqXHR.responseText || textStatus);
      	});
   	}

function updateQty(variantId, qty, locationId)
   	{
    	var myAuth = sessionGet("jwt");
      	var shopifyUrl = 'https://dch-webapi.azurewebsites.net/api/shopify/inventory/s5a/';
      	$.ajax({
        type: 'POST',
        url: shopifyUrl + variantId + '/' + qty + '/' + locationId,
        beforeSend: function (xhr) {
          	xhr.setRequestHeader('Authorization', 'Bearer ' + myAuth);
        }
      	}).done(function (data) {
        	console.log(data);
      	}).fail(function (jqXHR, textStatus, errorThrown) {
        	console.log(jqXHR.responseText || textStatus);
      	});
   	}

function retrieveInventoryId(variantId, sumOnHand, sawOnHand, easOnHand, webOnHand, snOnHand, mxcOnHand)
   	{
    	var myAuth = sessionGet("jwt");
      	var shopifyUrl = 'https://dch-webapi.azurewebsites.net/api/shopify/inventoryid/';
      	$.ajax({
        type: 'POST',
        url: shopifyUrl + 's5a' + '/' + variantId,
        beforeSend: function (xhr) {
          	xhr.setRequestHeader('Authorization', 'Bearer ' + myAuth);
        }
      	}).done(function (data) {
            var inventoryItemId = data.variant.inventory_item_id;
          	updateQty(inventoryItemId, sawOnHand, 14409039955);
            updateQty(inventoryItemId, easOnHand, 14409072723);
            updateQty(inventoryItemId, webOnHand, 14409105491);
          	updateQty(inventoryItemId, snOnHand, 14409007187);
            updateQty(inventoryItemId, mxcOnHand, 16617673);
      	}).fail(function (jqXHR, textStatus, errorThrown) {
        	console.log(jqXHR.responseText || textStatus);
      	});
   	}

function getOnHands(sku, id, hasVariants) {
		var myAuth = sessionGet("jwt");
  		var armsUrl = 'https://dch-webapi.azurewebsites.net/api/arms/product/';
		//console.log('Pulling site on-hands for SKU #' + sku);
		$.ajax({
			type: 'POST',
			url: armsUrl + sku,
			beforeSend: function (xhr) {
				xhr.setRequestHeader('Authorization', 'Bearer ' + myAuth);
			}
		}).done(function (data) {
			console.log(data);
			var returnAry = data.split('|');
			var sawOnHand = Math.round(returnAry[0] || 0);
			var easOnHand = Math.round(returnAry[1] || 0);
			var webOnHand = Math.round(returnAry[2] || 0);
			var donOnHand = Math.round(returnAry[3] || 0);
			var snOnHand = Math.round(returnAry[4] || 0);
			var mxcOnHand = Math.round(returnAry[5] || 0);
			var sumOnHand = parseInt(sawOnHand) + parseInt(easOnHand) + parseInt(webOnHand) + parseInt(donOnHand) + parseInt(snOnHand) + parseInt(mxcOnHand);
			var retailPrice = returnAry[6] || 0.00;
			var salePrice = returnAry[7] || 0.00;
			var msrp = returnAry[8] || 0.00;
          	
			//console.log('Per-site allocations for SKU ' + sku + ' are retrieved as ' + data);
			if (document.getElementById('result'))
			{
				if (document.getElementById('result').innerHTML == '' || hasVariants)
				{
                   
                if ($('.on-sale').length) {
                  console.log("this is on sale");
                  var staticPrice = $('.on-sale').attr('content');
                  console.log(staticPrice);
                  salePrice = staticPrice;
                }
                  	
					console.log('Updating on-hands for SKU ' + sku + ' which has Shopify product variant ID ' + id + ' to a quantity of ' + sumOnHand + ' and price of $' + salePrice);
					updateOnHands(id, sumOnHand, Math.round(salePrice));
					retrieveInventoryId(id, sumOnHand, sawOnHand, easOnHand, webOnHand, snOnHand, mxcOnHand); 
                  var text = "";
                  
                  if (sawOnHand == 1) {
                   text = " | Currently located at Diamond Cellar, Sawmill (Dublin, OH)";
                  }
                  
                  if (easOnHand == 1) {
                    text = " | Currently located at Diamond Cellar, Easton (Columbus, OH)";
                  }
                  
                  if (snOnHand == 1) {
                    text = " | Currently located at STORE 5a, Short North (Columbus, OH)";
                  
                  }
				  if (mxcOnHand == 1) {
                   text = " | Currently located at STORE 5a, Easton Market (Columbus, OH)";
                  }
                  
                  document.getElementById('result').innerHTML = text;
					//document.getElementById('ProductPrice-product-template').innerHTML = '$' + salePrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					var links = document.getElementsByTagName("link");
					for (var i = 0, len = links && links.length; i < len; ++i)
					{
						var link = links[i];
						var title = links[i].getAttribute("itemprop");
						if ( title == "availability")
						{
							if (sumOnHand > 0 && links[i].getAttribute("href") == "http://schema.org/OutOfStock")
							{
								location.reload(true);
							}
						//else if (sumOnHand == 0)
					//	{
						//	links[i].setAttribute("href", "http://schema.org/OutOfStock");
						//	document.getElementById("AddToCart-product-template").disabled = true;
						//	document.getElementById("AddToCartText-product-template").innerHTML = "Out of Stock";
					//}
					}
				}
			}
		}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log(jqXHR.responseText || textStatus);
		});
	}

function createUuid()  {
   return 'xxxxxxxxxxxxxxxyxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      	var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
      	return v.toString(16);
   		});
	}


function getCookie(name) {
		var re = new RegExp(name + "=([^;]+)");
		var value = re.exec(document.cookie);
		return (value != null) ? unescape(value[1]) : null;
	}


